import { createStore } from '@helpers/utils';

export const initialState = {
    dc_name: [],
    parahub_name: [],
    sales_area_name: [],
    page: 1,
    searchparam: null,
    dcSearch: null,
    saSearch: null,
    psnSearch: null,
    provinceSearch: null,
    citySearch: null,
    districtSearch: null,
    villageSearch: null,
    limit: 10,
    sort: 'dc_name.asc',
};

export const useFilters = createStore(initialState);
